import { GLOBAL_CONFIG_KEY } from './constants'

export { collectEntrypointConfig } from './collectEntrypointConfig'
export {
  parseAllScriptsConfig,
  resetAllScriptsParsingState,
} from './parseScriptConfig'

/**
 * Global config is a set of params put on the script tag to be applied
 * to all widgets on a page. We collect all the script tags and merge the global
 * config from multiple script tags into one.
 *
 * Possible sources of global config:
 * - script tag `data-fwparam_` attributes
 * - script tag `data-` attributes
 * - script tag `src` query params
 *
 * @returns The global configuration object
 */
export function getGlobalConfig(
  __window_dependency_injection: Window | undefined = typeof window !==
  'undefined'
    ? window
    : undefined,
) {
  return __window_dependency_injection?.[GLOBAL_CONFIG_KEY] || {}
}
